import React from "react";

import { Tooltip } from "antd";
import ToggleSwitch from "@/components/ui/ToggleSwitch";

function SectionToggles({
  toggleSelectAll,
  selectAllSections,
  sectionGeneration,
  handleTrackChangesToggle,
  trackChanges,
}) {
  return (
    <ul className="section_generator_panel_list">
      <li className="section_generator_panel_item_toggle">
        <div className="section_generator_panel_toggle_group">
          <Tooltip title="Toggle Select All Sections">
            <ToggleSwitch
              toggleOutput={toggleSelectAll}
              currentToggled={selectAllSections}
              disabled={sectionGeneration}
              label={"Select All"}
            />
          </Tooltip>
          <Tooltip title="Toggle Turn on Track Changes">
            <ToggleSwitch
              toggleOutput={handleTrackChangesToggle}
              currentToggled={trackChanges}
              disabled={sectionGeneration}
              label={"Track Changes"}
            />
          </Tooltip>
        </div>
        {/* <Tooltip title="Toggle Turn on User Font Styles">
            <ToggleSwitch
              toggleOutput={() => setUserStylesEnabled(!userStylesEnabled)}
              currentToggled={userStylesEnabled}
              disabled={true}
              label="User Font Styles"
            />
          </Tooltip> */}
      </li>
    </ul>
  );
}

export default SectionToggles;
